import * as fromDatatype from '../datatype-library/index';

export interface bl_inv_stock_replenishment_run_order_qty_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  location_code: fromDatatype.VarcharDatatypeInterface;
  loc_sales_last_30_days: fromDatatype.NumericDatatypeInterface;
  loc_qty_balance: fromDatatype.NumericDatatypeInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  inv_item_name: fromDatatype.VarcharDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  fi_item_name: fromDatatype.VarcharDatatypeInterface;
  loc_qty_approved: fromDatatype.NumericDatatypeInterface;
  loc_qty_reorder_manual: fromDatatype.NumericDatatypeInterface;
  loc_qty_reorder_calc: fromDatatype.NumericDatatypeInterface;
  supplier_guid: fromDatatype.GuidDataFieldInterface;
  supplier_code: fromDatatype.VarcharDatatypeInterface;
  supplier_name: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  unit_cost_method: fromDatatype.VarcharDatatypeInterface;
  unit_cost_value: fromDatatype.NumericDatatypeClass;
  action_logic: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  loc_qty_min_manual: fromDatatype.NumericDatatypeInterface;
  loc_qty_max_manual: fromDatatype.NumericDatatypeInterface;
  loc_qty_stock_balance_adjusted: fromDatatype.NumericDatatypeInterface;
  loc_qty_in_transit: fromDatatype.NumericDatatypeInterface;
  loc_qty_open_purchase_order: fromDatatype.NumericDatatypeInterface;
  loc_qty_requested: fromDatatype.NumericDatatypeInterface;
  comp_sales_last_30_days: fromDatatype.NumericDatatypeInterface;
  comp_qty_balance: fromDatatype.NumericDatatypeInterface;
  comp_qty_reserved: fromDatatype.NumericDatatypeInterface;
  comp_sales_order_in_queue: fromDatatype.NumericDatatypeInterface;
  comp_qty_open_purchase_order: fromDatatype.NumericDatatypeInterface;
  comp_qty_recommend_ai: fromDatatype.NumericDatatypeInterface;
  fulfill_option: fromDatatype.VarcharDatatypeInterface;
  loc_qty_recommend_ai: fromDatatype.NumericDatatypeInterface;
}

export class bl_inv_stock_replenishment_run_order_qty_line_RowClass implements bl_inv_stock_replenishment_run_order_qty_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  date_start: fromDatatype.TimestampTzDatatypeInterface;
  date_end: fromDatatype.TimestampTzDatatypeInterface;
  location_guid: fromDatatype.GuidDataFieldInterface;
  location_code: fromDatatype.VarcharDatatypeInterface;
  loc_sales_last_30_days: fromDatatype.NumericDatatypeInterface;
  loc_qty_balance: fromDatatype.NumericDatatypeInterface;
  inv_item_guid: fromDatatype.GuidDataFieldInterface;
  inv_item_code: fromDatatype.VarcharDatatypeInterface;
  inv_item_name: fromDatatype.VarcharDatatypeInterface;
  fi_item_guid: fromDatatype.GuidDataFieldInterface;
  fi_item_code: fromDatatype.VarcharDatatypeInterface;
  fi_item_name: fromDatatype.VarcharDatatypeInterface;
  loc_qty_approved: fromDatatype.NumericDatatypeInterface;
  loc_qty_reorder_manual: fromDatatype.NumericDatatypeInterface;
  loc_qty_reorder_calc: fromDatatype.NumericDatatypeInterface;
  supplier_guid: fromDatatype.GuidDataFieldInterface;
  supplier_code: fromDatatype.VarcharDatatypeInterface;
  supplier_name: fromDatatype.VarcharDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  uom_json: fromDatatype.JsonDatatypeInterface;
  unit_cost_method: fromDatatype.VarcharDatatypeInterface;
  unit_cost_value: fromDatatype.NumericDatatypeClass;
  action_logic: fromDatatype.VarcharDatatypeInterface;
  remarks: fromDatatype.VarcharDatatypeInterface;
  wf_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_guid: fromDatatype.GuidDataFieldInterface;
  wf_process_status_code: fromDatatype.VarcharDatatypeInterface;
  wf_resolution_guid: fromDatatype.GuidDataFieldInterface;
  wf_resolution_code: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  namespace: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  loc_qty_min_manual: fromDatatype.NumericDatatypeInterface;
  loc_qty_max_manual: fromDatatype.NumericDatatypeInterface;
  loc_qty_stock_balance_adjusted: fromDatatype.NumericDatatypeInterface;
  loc_qty_in_transit: fromDatatype.NumericDatatypeInterface;
  loc_qty_open_purchase_order: fromDatatype.NumericDatatypeInterface;
  loc_qty_requested: fromDatatype.NumericDatatypeInterface;
  comp_sales_last_30_days: fromDatatype.NumericDatatypeInterface;
  comp_qty_balance: fromDatatype.NumericDatatypeInterface;
  comp_qty_reserved: fromDatatype.NumericDatatypeInterface;
  comp_sales_order_in_queue: fromDatatype.NumericDatatypeInterface;
  comp_qty_open_purchase_order: fromDatatype.NumericDatatypeInterface;
  comp_qty_recommend_ai: fromDatatype.NumericDatatypeInterface;
  fulfill_option: fromDatatype.VarcharDatatypeInterface;
  loc_qty_recommend_ai: fromDatatype.NumericDatatypeInterface;
}
